import { createSelector } from '@ngrx/store';
import { State } from '@store/state';
import { getEmailEventTypesByProductIdMap } from '@store/products/products.selector';

const getDashboard = (state: State) => state.dashboard;

// Get current filters
export const getDashboardFilters = createSelector(
  getDashboard,
  (state) => state.dashboardFilter
);

export const getEventTypeList = createSelector(
  getEmailEventTypesByProductIdMap,
  getDashboardFilters,
  (map, filters) =>
    [...new Set(filters.productId.flatMap((id: string) => map[id] ?? []))]
      .sort((a, b) => a.localeCompare(b))
);
///

// Histogram sent mail
export const getHistogramMailSentApiCall = createSelector(
  getDashboard,
  (state) => state.chartData.histogramMailSent
);
export const getHistogramMailSentData = createSelector(
  getDashboard,
  (state) => state.chartData.histogramMailSent.data
);

// Deliverability Indicators
export const getDeliverabilityIndicatorsApiCall = createSelector(
  getDashboard,
  (state) => state.chartData.deliverabilityIndicators
);

// Thresholds
export const getThresholdsApiCall = createSelector(
  getDashboard,
  (state) => state.chartData.thresholds
);

// Providers Stats
export const getProvidersStatsApiCall = createSelector(
  getDashboard,
  (state) => state.chartData.providersStats
);
